import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoungeAccessComponent } from './lounge-access.component';
import { TextTooltipModule } from '@lib/components';
import { AmountFormatModule, DateFormatModule, StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { MilesFormatModule } from '@common/pipes/miles-format/miles-format.module';
import { TooltipDirectiveModule } from '@lib/directives';
import { LoungeAccessItemModule } from './lounge-access-item/lounge-access-item.module';

@NgModule({
  declarations: [LoungeAccessComponent],
  imports: [
    CommonModule,
    TextTooltipModule,
    TooltipDirectiveModule,
    TableSliderModule,
    StaticMsgModule,
    AmountFormatModule,
    DateFormatModule,
    MilesFormatModule,
    LoungeAccessItemModule,
  ],
  exports: [LoungeAccessComponent],
  providers: [StaticMsgPipe],
})
export class LoungeAccessModule {}
